import { render, staticRenderFns } from "./CoreTableIconButton.vue?vue&type=template&id=0212d84e&scoped=true&"
import script from "./CoreTableIconButton.vue?vue&type=script&lang=ts&"
export * from "./CoreTableIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./CoreTableIconButton.vue?vue&type=style&index=0&id=0212d84e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212d84e",
  null
  
)

export default component.exports